import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_forge_team = _resolveComponent("forge-team")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.allowed)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "ai-btn fpb",
          title: _ctx.label,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = true))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 24 24",
            fill: "currentColor"
          }, [
            _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" })
          ], -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.label), 1)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.open)
      ? (_openBlock(), _createBlock(_component_forge_team, {
          key: 1,
          modal: "",
          only: _ctx.kinds,
          "start-kind": _ctx.startKind || _ctx.kinds[0],
          "preset-team": _ctx.presetTeam || '',
          "preset-quarter": _ctx.presetQuarter,
          onApplied: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('applied'))),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = false))
        }, null, 8, ["only", "start-kind", "preset-team", "preset-quarter"]))
      : _createCommentVNode("", true)
  ], 64))
}